import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'stx-ui-dialog-export',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatDialogClose,
  ],
  styles: `
    :host {
      display: block;
    }
  `,
  template: `
    <h2 mat-dialog-title>Exportación de datos</h2>
    <mat-dialog-content>
      <p>
        ¿De que manera prefiere recibir la información? (Se descargará un
        archivo en el formato en el qué se seleccione)
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button
        cdkFocusInitial
        mat-button
        mat-dialog-close
      >
        Cerrar
      </button>
      <button
        mat-button
        mat-dialog-close="csv"
      >
        CSV
      </button>
      <button
        mat-button
        mat-dialog-close="pdf"
      >
        PDF
      </button>
    </mat-dialog-actions>
  `,
})
export class UiDialogExportComponent {}
